import { ILinkedEmail } from '@/entities/admin-app/email';
import { IUsePopUpUI, PopUpUI } from '@components/UI/PopUp';
import React from 'react';
import { Button, Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { UseFormReturnType } from '@mantine/form';
import { RenameMail } from '@/containers/pages/user/components/sections/linked-emails/modals/RenameMail';
import { IconPassword, IconPencil } from '@tabler/icons';
import { IconTrash } from '@tabler/icons-react';
import { ChangePasswordModal } from '@/containers/pages/user/components/sections/linked-emails/modals/ChangePasswordModal';
import { DeleteEmailModal } from '@/containers/pages/user/components/sections/linked-emails/modals/DeleteEmailModal';

interface EmailActionsParams extends IUsePopUpUI {
  isVisibleChangeButton: boolean;
  email: ILinkedEmail;
  form: UseFormReturnType<any>;
  sectionFormKey: string;
  currentId?: number;
  listEmails: ILinkedEmail[] | null;
  refetchUserInfo?: () => void;
}

const ActionResetPassTrigger = (props: IUsePopUpUI) => {
  const { setIsOpen } = props;
  const { t } = useTranslation();

  const handleOpen = () => setIsOpen(true);

  return (
    <Button
      justify="flex-start"
      fullWidth
      size="sm"
      variant="white"
      color="black"
      fw="lighter"
      onClick={handleOpen}
      leftSection={<IconPassword />}
    >
      {t('profile.changePassword')}
    </Button>
  );
};

const ActionRemoveMailTrigger = (props: IUsePopUpUI) => {
  const { setIsOpen } = props;
  const { t } = useTranslation();

  const handleOpen = () => setIsOpen(true);

  return (
    <Button
      fullWidth
      justify="flex-start"
      size="sm"
      variant="white"
      fw="lighter"
      color="red"
      onClick={handleOpen}
      leftSection={<IconTrash />}
    >
      {t('profile.removeMail')}
    </Button>
  );
};

const ActionRenameMailTrigger = (props: IUsePopUpUI) => {
  const { setIsOpen } = props;
  const { t } = useTranslation();

  const handleOpen = () => setIsOpen(true);

  return (
    <Button
      fullWidth
      size="sm"
      justify="flex-start"
      variant="white"
      color="black"
      fw="lighter"
      onClick={handleOpen}
      leftSection={<IconPencil />}
    >
      {t('profile.renameMail')}
    </Button>
  );
};

const EmailActions = (props: EmailActionsParams) => {
  const {
    isVisibleChangeButton,
    currentId,
    form,
    sectionFormKey,
    email,
    listEmails,
    refetchUserInfo
  } = props;

  return (
    <Flex p={6} gap={6} direction="column">
      {email?.IsCanRename && (
        <PopUpUI mobileSize="100%" desktopPosition="left-start" trigger={ActionRenameMailTrigger}>
          {(params) => <RenameMail {...params} selectedEmail={email} onSuccess={refetchUserInfo} />}
        </PopUpUI>
      )}
      {!isVisibleChangeButton && (
        <PopUpUI mobileSize="100%" desktopPosition="left-start" trigger={ActionResetPassTrigger}>
          {(params) => (
            <ChangePasswordModal {...params} selectedEmail={email} onSuccess={refetchUserInfo} />
          )}
        </PopUpUI>
      )}
      <PopUpUI mobileSize="100%" desktopPosition="left-start" trigger={ActionRemoveMailTrigger}>
        {(params) => (
          <DeleteEmailModal
            {...params}
            selectedEmail={email}
            editUser
            currentId={currentId}
            form={form}
            sectionFormKey={sectionFormKey}
            listEmails={listEmails}
            onSuccess={refetchUserInfo}
          />
        )}
      </PopUpUI>
    </Flex>
  );
};

export default EmailActions;
